
import { Component, Vue, Prop} from 'vue-property-decorator';
import StepBase from "../StepBase.vue";
import { stepInfoType } from "@/types/Application";

import EnfrcQuestionnaire from "./EnfrcQuestionnaire.vue"
import DetermineAnAmountOwingForExpenses from "./DetermineAnAmountOwingForExpenses.vue"
import AboutTheOrderEnforcement from "./AboutTheOrderEnforcement.vue";
import EnforceAgreementOrder from "./EnforceAgreementOrder.vue";
import EnforceChangeSetAsideDetermination from "./EnforceChangeSetAsideDetermination.vue";
import DetermineArrears from "./DetermineArrears.vue";
import ReviewYourAnswersEnfrc from "./reviewAE/ReviewYourAnswersEnfrc.vue";
import PreviewForm26Enfrc from "./reviewAE/PreviewForm26Enfrc.vue";
import PreviewForm27Enfrc from "./reviewAE/PreviewForm27Enfrc.vue";
import PreviewForm28Enfrc from "./reviewAE/PreviewForm28Enfrc.vue";
import PreviewForm29Enfrc from "./reviewAE/PreviewForm29Enfrc.vue";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
      StepBase,
      EnfrcQuestionnaire,
      DetermineAnAmountOwingForExpenses,
      AboutTheOrderEnforcement,
      EnforceAgreementOrder,
      EnforceChangeSetAsideDetermination,
      DetermineArrears,
      ReviewYourAnswersEnfrc,
      PreviewForm26Enfrc,
      PreviewForm27Enfrc,
      PreviewForm28Enfrc,
      PreviewForm29Enfrc,
    }
})
export default class EnforcementAgreeStep extends Vue {
  
  @Prop({required: true})
  step!: stepInfoType;

  @applicationState.State
  public stPgNo!: stepsAndPagesNumberInfoType;

}
